<template>
    <div style="padding-bottom: 90px;" id="contenddash">
        <nav class="navbar navbar-dark " style="padding-right: 30px; padding-left: 30px;">

            <i style="font-size: 20px;" @click.prevent="mtdvoltames()" class="bi bi-chevron-left"></i>
            <h6>{{ mesatual }}</h6>
            <i style="font-size: 20px;" @click.prevent="mtdavancames()" class="bi bi-chevron-right"></i>
        </nav>


        <div class="col-12" style="margin-top: 10px;">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header card-dash">
                            <span class="tit-card-dash">Despesas com metas</span>
                        </div>
                        <div class="card-body" style="padding-bottom: 10px;">
                            <div class="row">
                                <div class="col-md-12" style="display: flex; justify-content: center;">
                                    <graficopie :titulo="''" :subtitulo="''" :tema="'westeros'" :rotulo="'Det:'"
                                        :legendas="legendadespesameta" :dados="dadosdespesasmeta"
                                        :visualizarlegenda="true" :posicaolabel="'outside'"></graficopie>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12" style="padding-right: 33px;">
                                    <div v-for="(dados, index) in dadosdespesascateg" :key="index"
                                        style="padding-top: 10px;" class="row">
                                        <div class="col-8">
                                            <span style="color: #7f8a99 important;">{{ dados.name }}</span>
                                        </div>
                                        <div class="col-4">
                                            <span class="badge badge-dark bg-dark bdt"> {{
                                                mtdformatavalordecimal(dados.value, 'R$')}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12" style="margin-top: 10px;">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header card-dash">
                            <span class="tit-card-dash">Metas e objetivos</span>
                        </div>
                        <div class="card-body" style="padding-bottom: 10px;">
                            <template v-if="lstmetas.length > 0">
                                <div v-for="(meta, indmeta) in lstmetas" :key="indmeta" class="row">
                                    <div class="card">
                                        <div class="card-header card-dash">

                                            <span class="tit-card-dash"><i style="font-size: 26px;"
                                                    :class="'bi ' + meta.adesivo"></i> {{
                                                meta.descricao }}</span>
                                        </div>
                                        <!-- <div class="card-body" style="padding-bottom: 10px;">
                                            <div class="row">
                                                <div class="progress">
                                                    <div class="progress-bar" role="progressbar"
                                                        :style="'width: ' + parseInt(meta.percentual) + '%;'"
                                                        :aria-valuenow="parseInt(meta.percentual)" aria-valuemin="0"
                                                        aria-valuemax="100">
                                                        {{ parseInt(meta.percentual) }}% da meta</div>
                                                </div>
                                            </div>
                                        </div> -->
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div style="display: flex; justify-content: center;">
                                    <span style="font-size: 12px;">Sem metas no momento</span>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import util from '../util.js';
// import globals from '../globals.js';
import GraficoPie from '../graficos/graficodoughnut.vue';
export default {
    name: 'dash',
    data: function () {
        const hoje = new Date();
        return {
            mesatual: this.getNomeMes(hoje),  // Formata o mês atual para exibir no template
            peridosql: this.getPeriodoSQL(hoje), // Formata o período SQL inicial
            dataAtual: hoje, // Guarda a data atual para manipulação

            legendadespesameta: [],
            dadosdespesasmeta: [],

            lstmetas: [],
        };
    },
    components: {
        'graficopie': GraficoPie,
    },
    methods: {
        mtdformatavalordecimal(valor, digitos) {
            return util.formatarvalor(valor, digitos);
        },
        mtdavancames() {
            this.dataAtual.setMonth(this.dataAtual.getMonth() + 1); // Incrementa o mês
            this.atualizaMesPeriodo();
        },
        // Retrocede para o mês anterior
        mtdvoltames() {
            this.dataAtual.setMonth(this.dataAtual.getMonth() - 1); // Decrementa o mês
            this.atualizaMesPeriodo();
        },
        // Atualiza o mês e o período SQL
        atualizaMesPeriodo() {
            this.mesatual = this.getNomeMes(this.dataAtual);
            this.peridosql = this.getPeriodoSQL(this.dataAtual);



            this.mtdexecutadash();
        },
        // Retorna o nome do mês com o ano
        getNomeMes(data) {
            const nomeMeses = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
                "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
            return `${nomeMeses[data.getMonth()]} ${data.getFullYear()}`;
        },
        // Retorna o período SQL de acordo com o mês e ano da data
        getPeriodoSQL(data) {

            //verifica se a data que selecionei está no futuro
            let new_hj = new Date();
            let legdata = data;

            if (legdata > new_hj) {
                this.futuro = true
            } else {
                this.futuro = false
            }


            const ano = data.getFullYear();
            const mes = String(data.getMonth() + 1).padStart(2, '0'); // Formata o mês com dois dígitos
            const ultimoDia = new Date(ano, data.getMonth() + 1, 0).getDate(); // Último dia do mês
            return `'${ano}-${mes}-01 00:00:00' and '${ano}-${mes}-${ultimoDia} 23:59:59'`;
        },
        mtdexecutadash() {
            var vself = this;

            let parametros = [
                { parametro: 'idusuario', valor: localStorage.getItem('iduser') },
                { parametro: 'op', valor: 'despesascommetas' },
                { parametro: 'periodo', valor: vself.peridosql },
                { parametro: 'previsao', valor: vself.futuro ? 1 : 0 }
            ];
            let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/relatorio.php');
            retorno.then(function (response) {

                vself.lstmetas = response.data.lstmetas;

                for (let index = 0; index < vself.lstmetas.length; index++) {
                    let tmpmeta = {
                        value : parseFloat(vself.lstmetas[index].totalancado),
                        name  : vself.lstmetas[index].descricao,
                    }
                    vself.dadosdespesasmeta.push(tmpmeta)
                }
                vself.legendadespesameta = util.gerardadoslegendagrafico(vself.dadosdespesasmeta);
            }).catch(function (response) {

            });

        },
    },
    mounted() {
        let vself = this
        vself.mtdexecutadash();

    }
}
</script>

<style>
.bdt {
    width: 100px !important;
    border-radius: 23px !important;
}
</style>